/**
 * Trending-search chips in the search drawer. Clicking a chip fills the drawer's search
 * field and re-dispatches `input`, so s-live-form fetches live results without leaving
 * the page. The chips stay plain links (/search?q=…) when scripts are unavailable.
 */
class SSearchSuggest extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      const chip = event.target instanceof Element ? event.target.closest('a[data-term]') : null;
      if (!chip || event.metaKey || event.ctrlKey || event.shiftKey) return;
      const input = document.getElementById(this.dataset.input || '');
      if (!(input instanceof HTMLInputElement)) return;
      event.preventDefault();
      input.value = chip.dataset.term || '';
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-search-suggest')) customElements.define('s-search-suggest', SSearchSuggest);
